import React from 'react';

interface TitleValueProps {
  title: string;
  value: React.ReactNode;
  className?: string;
}

/**
 * A reusable component for displaying a title-value pair
 * Commonly used in forms, cards, and data display components
 */
export const TitleValue = ({ title, value, className = '' }: TitleValueProps) => (
  <div className={`flex flex-col ${className}`}>
    <span className="text-xs font-medium text-gray-500 mb-1">{title}</span>
    <span className="text-sm">{value}</span>
  </div>
);
